module.exports = __webpack_public_path__ + "static/media/blog6.5f6dba46.png";